module.exports = __webpack_public_path__ + "media/images/gift-3-415741f7d6c216da31b8fa442e2e7a49.svg";